import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import {
  boldenBacktickText,
} from "apps/website/utils/website/boldenBacktickText";
import Illustration from "apps/website/components/base/Illustration/Illustration";

import { IEducationalCard } from "../MessagingCard.map";

export const EducationalCard = ({ title, description, footer, illustration }: IEducationalCard) => (
  <div className="flex flex-col gap-2" data-component={EducationalCard.name}>
    <div className="flex gap-3">
      { illustration && (<Illustration className="shrink-0" size="medium" {...illustration} />) }

      <div className="flex flex-col gap-2">
        { title && <TextSubtitle size={2}>{ title }</TextSubtitle> }
        { typeof description === "string" ? (
          <TextBody size={2}>{ boldenBacktickText(description) }</TextBody>
        ) : (
          description
        ) }
      </div>
    </div>
    { footer && <TextBody size={3}>{ footer }</TextBody> }
  </div>
);
